import api from "../../../settings/api";
import { clearString } from "../../../utils/functions";
import { AxiosResponse } from "axios";
import { Action } from "redux-saga";
import { call, CallEffect, PutEffect } from "redux-saga/effects";

export interface Fetch {
    zipcode: string;
    callback: (success: boolean, code?: string) => void;
}

export interface SearchAddressAction {
    type: string;
    payload: Fetch;
}

export default function* searchAddressByZipcode({
    payload,
}: SearchAddressAction): Generator<
    CallEffect<unknown> | PutEffect<Action>,
    void,
    AxiosResponse
> {
    try {
        const data = {
            cep: clearString(payload.zipcode),
        };

        const response = yield call(api.post, `/v1/endereco/endereco-cep`, data);

        if (response?.data?.serviceMessage?.codigoRetorno === 0) {
            yield call(payload.callback, true, response?.data?.dadosEndereco);
        } else {
            yield call(payload.callback, false, "error");
        }

    } catch (error) {
        yield call(payload.callback, false, "timeout");
    }
}